const DeviceDetectionSettings = {
  breakpoint: 800
}

export const mediaQueryMobile = matchMedia(
  `(max-width: ${DeviceDetectionSettings.breakpoint - 1}px)`
)
const mediaQueryDesktop = matchMedia(
  `(min-width: ${DeviceDetectionSettings.breakpoint}px)`
)

/** @returns {{ isDesktop: boolean, isMobile: boolean }} */
export function useDeviceDetection() {
  const mobileMatches = mediaQueryMobile.matches
  const desktopMatches = mediaQueryDesktop.matches

  return { isDesktop: desktopMatches, isMobile: mobileMatches }
}

/** @returns {boolean} */
export function isMobile() {
  return mediaQueryMobile.matches
}

/** @returns {boolean} */
export function isDesktop() {
  return mediaQueryDesktop.matches
}

export const mediaQueryLarge = mediaQueryDesktop
